import { faChevronLeft, faUpload, faTimes, faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { LabsGameProposalProjectInfoAPI, LabsGameProposalTestPlanDetailsAPI, LabsGameQuestionListAPI, LabsGameTestPlanDetailsAPI, LabsQuestionComposeAPI, LabsQuestionOverviewAPI, QuestionDetailAPI, QuestionsBySourceAPI } from "../TestManagementApi";
import LimitModal from '../AddTest/AddTestPhase3/Modal/LimitModal';
import GenreModal from '../AddTest/AddTestPhase3/Modal/GenreModal';
import CustomNavLink from '../AddTest/components/CustomNavLink';
import { GameProposalStepAvailabilityAPI } from "../AddTest/AddTestApi";
import { GameProposalStepAvailabilityResponse } from "../types/Response";
import OnJudgingSubjectiveQuestionModal from "../AddTest/AddTestPhase3/Modal/OnJudgingSubjectiveQuestionModal";
import OnJudgingMultipleQuestionModal from "../AddTest/AddTestPhase3/Modal/OnJudgingMultipleQuestionModal";
import { parsingPlatformText } from "../../../../utils/platformUtils";
import { formatDate } from '../../../../utils/dateUtils';

type MultipleQuestion = {
  questionId: number;
  content: string;
  category: string;
  count: number;
  custom: boolean;
  choices: Array<{ id: number; content: string }>;
  rejectionReason: string;
}

const Main = styled.main`
  background-color: #f8f9fa;
  width: 100%;
  height: 90vh;
  padding-left: 195px;
  overflow-y: auto;
`;

const TopWrapper = styled.div`
  padding-left: 80px;
  border-bottom: 1px solid #ededed;
  display: flex;
  flex-direction: column;
  gap: 34px;
  padding-top: 30px;
  
`;

const TopContainer = styled.div`
  // width: 1280px;
  width: 95%;
  height: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  margin-bottom: 14px;
`;

const TopTitle = styled.span`
  // margin-top: 100px;
  color: #2282e9;
  font-size: 20px;
  font-weight: 700;
`;


const TopBtn = styled.button`
  width: 160px;
  height: 55px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #ededed;
  color: #c0c0c0;
  font-weight: 600;
  cursor: pointer;
`;

const PreviewBtn = styled(TopBtn)`
  color: white;
  background-color: #2282e9;
`;

const SaveBtn = styled(TopBtn)`
  color: #2282e9;
  border: 1px solid #2282e9;
`;

const NavCotainer = styled.div`
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 1280px;
  height: 37px;
`;

const Nav = styled.div`
  width: 165px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const ContentWrapper = styled.div`
  padding-top: 70px;
  padding-left: 125px;
  margin-bottom: 5%;
`;

const PrimeTitle = styled.span`
  font-weight: 600;
  font-size: 14px;

`;

const Title = styled.span`
  font-weight: 600;
  font-size: 18px;
  // padding-bottom: 20%;
`;

const Comment = styled.span`
  display: block;
  line-height: 26px;
  color: #9f9f9f;
  margin-top: 8px;
  margin-bottom: 20px;
`;


const PrimeContainer = styled.div`
padding: 3%;
margin-top: 1%;
border-radius: 10px;
background-color: white;
// margin-bottom: 5%;
`;

const QuestionBox = styled.div`
  // width: 1280px;
  width: 90%;
  height: 300px;
  border-radius: 10px;
  background-color: white;
  border: 1px solid #EBF5FF;
  margin-bottom: 10px;
  overflow-y: auto;
  padding: 12px;
  margin-bottom: 5%;
`;

const AddQuestionBtn = styled.button`
  display: block;
  // width: 1280px;
  width: 90%;
  height: 49px;
  border-radius: 5px;
  border: 1px solid #2282e9;
  background-color: white;
  margin-bottom: 70px;
  font-weight: 600;
  color: #2282e9;
  cursor: pointer;
`;

const DraggableList = styled.div`
  width: 100%;
  position: relative;
`;

const DraggableItem = styled.div`
  margin-bottom: 12px;
  position: relative;
  height: 40px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const QuestionItemContainer = styled.div<{ isCustom?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: ${props => props.isCustom ? 'white' : '#EBF5FF'};
  border: 1px solid ${props => props.isCustom ? '#2282e9' : 'white'};
  border-radius: 4px;
  user-select: none;
  height: 40px;
  box-sizing: border-box;
`;

const QuestionText = styled.div<{ hasDeleteButton?: boolean }>`
  flex: 1;
  margin-right: ${props => props.hasDeleteButton ? '60px' : '0'};
  font-size: 14px;
  color: ${props => props.hasDeleteButton ? '#2282e9' : '#333'};
  margin-left: 50px;
`;

const ActionButton = styled.button`
  height: 100%;
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 14px;
  margin-left: auto;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
`;

// 테스트 정보 관련 스타일드 컴포넌트
const TestInfoContainer = styled.div`
  margin-top: 2%;
  width: 90%;
  height: 50%;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
  display: flex;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const GameImageContainer = styled.div`
  width: 30%;
  height: 30%;
  margin-right: 3%;
  margin-left: 3%;
  padding-top: 3%;
  overflow: hidden;
  border-radius: 5px;
`;

const GameImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const InfoTable = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 120px 1fr;
  grid-gap: 30px;
  padding: 3%;
`;

const InfoLabel = styled.div`
  color: #797979;
  font-size: 14px;
`;

const InfoValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-weight: bold;
`;

export default function ApprovedTestEdit() {
  const [questionDetails, setQuestionDetails] = useState<any>(null);
  const { gameProposalId } = useParams();
  console.log(`gameProposalId: `, gameProposalId);

  const [multipleQuestionModal, setMultipleQuestionModal] = useState(false);
  const [subjectiveQuestionModal, setSubjectiveQuestionModal] = useState(false);

  const closeMultipleQuestionModal = () => {
    setMultipleQuestionModal(false);
  };

  const closeSubjectiveQuestionModal = () => {
    setSubjectiveQuestionModal(false);

  };


  interface LabsGameTestPlanDetailsAPIResponse {
    gameId: number;
    title: string;
    companyName: string;
    recruitStartedAt: string;
    recruitExpiredAt: string;
    startedAt: string;
    expiredAt: string;
    desiredTesterCount: number;
    platforms: Array<string>;
    gameCategory: string;
    rewards: number;
    bannerUrl: string;
  }

  const { data: gameProposalStepAvailabilityData } = useQuery<LabsGameTestPlanDetailsAPIResponse>({
    queryKey: ["gameProposalStepAvailability", gameProposalId],
    queryFn: async () => {
      const response = await LabsGameTestPlanDetailsAPI(Number(gameProposalId));
      return response.data;
    },
    // initialData: {
    //   "testPlanAvailable": true,
    //   "projectInfoAvailable": false,
    //   "questionCompositionAvailable": false,
    //   "estimateAvailable": false,
    //   "previewAvailable": false,
    //   "submitAvailable": true,
    //   "testPlanSavable": true,
    //   "projectInfoSavable": false,
    //   "questionCompositionSavable": false
    // },
    enabled: true
  });

  const { data: gameQuestionListData } = useQuery({
    queryKey: ["gameQuestionList", gameProposalId],
    queryFn: async () => {
      const response = await LabsGameQuestionListAPI(Number(gameProposalId));
      return response.data;
    },
  });

  const fetchQuestionDetailMutation = useMutation({
    mutationFn: (questionId: number) => QuestionDetailAPI(questionId),
    onSuccess: (response) => {
      setQuestionDetails(response.data);
      return response.data;
    }
  });

  const handleEditMultipleChoiceQuestion = (questionId: number) => {

    setMultipleQuestionModal(true);
    fetchQuestionDetailMutation.mutate(questionId); // TODO
  };

  const handleEditSubjectiveQuestion = (question: any) => {
    fetchQuestionDetailMutation.mutate(question.questionId);
    setSubjectiveQuestionModal(true);
  };

  return (
    <Main>
      {multipleQuestionModal && (
        <OnJudgingMultipleQuestionModal
          close={closeMultipleQuestionModal}
          data={questionDetails}
        />
      )}

      {subjectiveQuestionModal && (
        <OnJudgingSubjectiveQuestionModal
          close={closeSubjectiveQuestionModal}
          data={questionDetails}
        />
      )}

      <TopWrapper>
        <TopContainer>
          <Link to="/home/test-list/add" style={{ textDecoration: "none" }}>
            <TopTitle>
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{ marginRight: "20px" }}
              />
              테스트 수정하기
            </TopTitle>
          </Link>
          
        </TopContainer>
        <NavCotainer>
          <CustomNavLink
            to={`/home/test/modification/${gameProposalId}`}
            status={true}
            isActive={false}
          >
            1. 내용 수정하기
          </CustomNavLink>
          <CustomNavLink
            to={`/home/test-list/${gameProposalId}/edit`}
            isActive={true}
          >
            2. 테스트 플랜 확인
          </CustomNavLink>
        </NavCotainer>
      </TopWrapper>
      <ContentWrapper>
        <PrimeTitle>
          테스트 정보
        </PrimeTitle>

        {/* 테스트 정보 컴포넌트 */}
        <TestInfoContainer>
          <GameImageContainer>
            <GameImage src={gameProposalStepAvailabilityData?.bannerUrl} alt="게임 이미지" />
          </GameImageContainer>

          <InfoTable>
            <InfoLabel>게임이름</InfoLabel>
            <InfoValue>{gameProposalStepAvailabilityData?.title}</InfoValue>

            <InfoLabel>개발사</InfoLabel>
            <InfoValue>{gameProposalStepAvailabilityData?.companyName}</InfoValue>

            <InfoLabel>모집기간</InfoLabel>
            <InfoValue>
              {formatDate(gameProposalStepAvailabilityData?.recruitStartedAt)} - {formatDate(gameProposalStepAvailabilityData?.recruitExpiredAt)}
            </InfoValue>

            <InfoLabel>진행기간</InfoLabel>
            <InfoValue>
              {formatDate(gameProposalStepAvailabilityData?.startedAt)} - {formatDate(gameProposalStepAvailabilityData?.expiredAt)}
            </InfoValue>

            <InfoLabel>피험 유저수</InfoLabel>
            <InfoValue>{gameProposalStepAvailabilityData?.desiredTesterCount}명</InfoValue>

            <InfoLabel>게임 플랫폼</InfoLabel>
            <InfoValue>{parsingPlatformText(gameProposalStepAvailabilityData?.platforms)}</InfoValue>

            <InfoLabel>게임 테스트 유형</InfoLabel>
            <InfoValue>{gameProposalStepAvailabilityData?.gameCategory}</InfoValue>

            <InfoLabel>지급재화</InfoLabel>
            <InfoValue>{gameProposalStepAvailabilityData?.rewards.toLocaleString()} 포인트 </InfoValue>
          </InfoTable>
        </TestInfoContainer>
        
        <div style={{ marginTop: '3%' }}>
          <PrimeTitle>질문 구성</PrimeTitle>
        

        <PrimeContainer>
          <Title>객관식 질문</Title>
          <Comment>현재 총 {gameQuestionListData?.multipleChoiceQuestions.filter((q: { custom: boolean; }) => !q.custom).length} 문항</Comment>
          <QuestionBox>
            <DraggableList>
              {gameQuestionListData?.multipleChoiceQuestions
                .filter((question: { custom: boolean; }) => !question.custom) // custom이 false인 것만 표시
                .map((question: { questionId: number; content: string; }, index: number) => (
                  <DraggableItem key={question.questionId.toString()}>
                    <QuestionItemContainer isCustom={false}>
                      <QuestionText hasDeleteButton={false}>
                        {question.content}
                      </QuestionText>
                    </QuestionItemContainer>
                  </DraggableItem>
                ))}
            </DraggableList>
          </QuestionBox>
          <Title>주관식 질문</Title>
          <Comment>현재 총 {gameQuestionListData?.subjectiveQuestions.filter((q: { custom: boolean; }) => !q.custom).length} 문항</Comment>
          <QuestionBox>
            <DraggableList>
              {gameQuestionListData?.subjectiveQuestions
                .filter((question: { custom: boolean; }) => !question.custom) // custom이 false인 것만 표시
                .map((question: { questionId: number; content: string; }, index: number) => (
                  <DraggableItem key={question.questionId.toString()}>
                    <QuestionItemContainer isCustom={false}>
                      <QuestionText hasDeleteButton={false}>
                        {question.content}
                      </QuestionText>
                    </QuestionItemContainer>
                  </DraggableItem>
                ))}
            </DraggableList>
          </QuestionBox>

          <Title>나의 추가 질문</Title>
          <div style={{ padding: "10px" }} />
          <QuestionBox>
            <DraggableList>
              {/* 객관식 커스텀 질문 */}
              {gameQuestionListData?.multipleChoiceQuestions
                .filter((question: { custom: boolean; }) => question.custom) // custom이 true인 질문만 표시
                .map((question: { questionId: number; content: string; }, index: number) => (
                  <DraggableItem key={`custom-multiple-${question.questionId}`}>
                    <QuestionItemContainer isCustom={true}>
                      <QuestionText hasDeleteButton={true}>
                        {question.content} (객관식)
                      </QuestionText>
                      <ActionButton onClick={() => handleEditMultipleChoiceQuestion(question.questionId)}>
                        확인
                      </ActionButton>
                    </QuestionItemContainer>
                  </DraggableItem>
                ))}

              {/* 주관식 커스텀 질문 */}
              {gameQuestionListData?.subjectiveQuestions
                .filter((question: { custom: boolean; }) => question.custom) // custom이 true인 질문만 표시
                .map((question: { questionId: number; content: string; }, index: number) => (
                  <DraggableItem key={`custom-subjective-${question.questionId}`}>
                    <QuestionItemContainer isCustom={true}>
                      <QuestionText hasDeleteButton={true}>
                        {question.content} (주관식)
                      </QuestionText>
                      <ActionButton onClick={() => handleEditSubjectiveQuestion(question)}>
                        확인
                      </ActionButton>
                    </QuestionItemContainer>
                  </DraggableItem>
                ))}
            </DraggableList>
          </QuestionBox>
          <div style={{ marginBottom: '-5%' }}></div>
        </PrimeContainer>
        </div>
      </ContentWrapper>
    </Main>
  );

}

